const About = () => {
    return ( 
        <div className="w-full flex flex-col h-full py-12 overflow-y-auto">
            <div className="text-lg w-full">
                <p className="font-bold">
                    Who are we?
                </p>
                <p>We are a trustful pre made website selling team.</p>
            </div>
            <div className="text-lg w-full mt-4">
                <p className="font-bold">
                    What we do?
                </p>
                <p>- Design websites <br/> - Develop websites <br/> - Host websites <br/> - Sell websites <br/></p>
            </div>

            <div className="text-lg w-full mt-4">
                <p className="font-bold">
                    How to cantact us ?
                </p>
                <p>- Call us : +94766743755 <br/> - Mail us : mrclocktd@gmail.com <br/> </p>
            </div>
        </div>
     );
}
 
export default About;